export const HERO_MEDIA_HEIGHT_DESKTOP = '312px';
export const HERO_MEDIA_HEIGHT_MOBILE = '280px';
export const MIN_HERO_SECTION_HEIGHT = '360px';
export const CAROUSEL_AUTO_ADVANCE_MS = 6000;
export const CAROUSEL_PLAYER_HEIGHT = '24px';
export const HERO_SECTION_PADDING_BLOCK_START = '1100';